import { render } from "./NutricionMenuBloques.vue?vue&type=template&id=7d3d5f3f"
import script from "./NutricionMenuBloques.vue?vue&type=script&lang=js"
export * from "./NutricionMenuBloques.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__